import { NgxDropzoneModule } from "ngx-dropzone";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TaskCardComponent } from "./components/task-card/task-card.component";
import { BottomPaneComponent } from "./components/vertical-split-container/bottom-pane/bottom-pane.component";
import { TopPaneComponent } from "./components/vertical-split-container/top-pane/top-pane.component";
import { VerticalSplitPaneComponent } from "./components/vertical-split-container/vertical-split-pane.component";
import { SharedThemeModule } from "@kno2/layout/theme";
import { TextNormalizationPipe } from "./pipes/text-normalization.pipe";
import { GridComponent } from "./components/grid/grid.component";
import { AgGridModule } from "ag-grid-angular";
import { ActionsCellRendererComponent } from "./components/grid/actions-cell-renderer/actions-cell-renderer.component";
import { ResultStatusPipe } from "./pipes/result-status.pipe";
import { ResultCountPipe } from "./pipes/result-count.pipe";
import { FormControlDirective } from "./directives/form-control/form-control.directive";
import { ConfirmOrDenyComponent } from "./components/dialog/confirm-or-deny/confirm-or-deny.component";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IsoToDatePipe } from "./pipes/iso-to-date.pipe";
import { HtmlTipComponent } from "./components/html-tip/html-tip.component";
import { FeatureToggleDirective } from "../shared/features/feature-toggle.directive";
import { GridPageSizeSelectComponent } from "./components/grid/page-size-select/grid-page-size-select.component";
import { GridSearchComponent } from "./components/grid/search/grid-search.component";
import { TagsInputComponent } from "./components/tags-input/tags-input.component";
import { GenderPipe } from "./pipes/gender.pipe";
import { AppendFileExtensionDirective } from "./directives/append-file-extension/append-file-extension.directive";
import { TelephoneFormatterDirective } from "./directives/telephone-formatter/telephone-formatter.directive";
import { AlertComponent } from "./alert/alert.component";
import { NgPipesModule } from "ngx-pipes";
import { GridTooltipCellRendererComponent } from "./components/grid/tooltip-cell-renderer/grid-tooltip-cell-renderer.component";
import { FileSizePipe } from "./pipes/file-size.pipe";
import { InputMaskModule } from "@ngneat/input-mask";
import { SplitButtonComponent } from "./components/split-button/split-button.component";
import { AutoFocusDirective } from "./directives/autofocus/auto-focus.directive";
import { CustomModalHeaderComponent } from "./components/custom-modal-header/custom-modal-header.component";
import { FileDropzoneComponent } from "../shared/file-dropzone/file-dropzone.component";
import { ControlPanelContainerComponent } from "./components/control-panel-layout/control-panel-container.component";
import { ControlPanelItemBodyDirective } from "./components/control-panel/item-body/control-panel-item-body.directive";
import { ControlPanelComponent } from "./components/control-panel/control-panel.component";
import { SocialSecurityNumberFormatterDirective } from "./directives/social-security-number-formatter/social-security-number-formatter.directive";
import { ActionBarComponent } from "./components/action-bar/action-bar.component";
import { FileDropzoneOverlayDirective } from "./directives/file-dropzone-overlay.directive";
import { NgxViewerDirective } from "./directives/ngx-viewer/ngx-viewer.directive";

@NgModule({
    imports: [CommonModule, RouterModule, SharedThemeModule, AgGridModule, FormsModule, ReactiveFormsModule, NgPipesModule, InputMaskModule, NgxDropzoneModule],
    declarations: [
        ConfirmOrDenyComponent,
        FileSizePipe,
        GenderPipe,
        IsoToDatePipe,
        ResultCountPipe,
        ResultStatusPipe,
        TextNormalizationPipe,
        TaskCardComponent,
        ActionsCellRendererComponent,
        GridComponent,
        BottomPaneComponent,
        TopPaneComponent,
        VerticalSplitPaneComponent,
        FormControlDirective,
        HtmlTipComponent,
        FeatureToggleDirective,
        GridPageSizeSelectComponent,
        GridSearchComponent,
        TagsInputComponent,
        AppendFileExtensionDirective,
        TelephoneFormatterDirective,
        AlertComponent,
        GridTooltipCellRendererComponent,
        SplitButtonComponent,
        AutoFocusDirective,
        CustomModalHeaderComponent,
        FileDropzoneComponent,
        ControlPanelContainerComponent,
        ControlPanelItemBodyDirective,
        ControlPanelComponent,
        SocialSecurityNumberFormatterDirective,
        ActionBarComponent,
        FileDropzoneOverlayDirective,
        NgxViewerDirective
    ],
    exports: [
        NgPipesModule,
        CommonModule,
        ConfirmOrDenyComponent,
        SharedThemeModule,
        FileSizePipe,
        GenderPipe,
        IsoToDatePipe,
        ResultCountPipe,
        ResultStatusPipe,
        TextNormalizationPipe,
        TaskCardComponent,
        GridComponent,
        ActionsCellRendererComponent,
        BottomPaneComponent,
        TopPaneComponent,
        VerticalSplitPaneComponent,
        FormControlDirective,
        HtmlTipComponent,
        FeatureToggleDirective,
        GridPageSizeSelectComponent,
        GridSearchComponent,
        TagsInputComponent,
        AppendFileExtensionDirective,
        TelephoneFormatterDirective,
        NgxViewerDirective,
        AlertComponent,
        InputMaskModule,
        SplitButtonComponent,
        AutoFocusDirective,
        CustomModalHeaderComponent,
        FileDropzoneComponent,
        ControlPanelContainerComponent,
        ControlPanelComponent,
        SocialSecurityNumberFormatterDirective,
        ActionBarComponent,
        FileDropzoneOverlayDirective
    ]
})
export class SharedUiCommonModule {}
